import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router';
import type { WorkItem } from '../../config/work';
import { cn } from '../../lib/utils';

interface WorkCardProps { item: WorkItem; featured?: boolean; }

function classification(item: WorkItem) {
  const kind = item.kind === 'concept' ? 'Concept' : 'Client Project';
  const service = item.serviceTypes.includes('business-websites') ? 'Business Website' : 'Website';
  return `${kind} · ${service} · ${item.industry}`;
}

export function WorkCard({ item, featured = false }: WorkCardProps) {
  const primaryLink = item.directHref ? (
    <a className="work-card__link link-underline" data-arrow="true" href={item.directHref}>View work <ArrowUpRight size={17} /></a>
  ) : (
    <Link className="work-card__link link-underline" data-arrow="true" to={`/work/${item.slug}`}>View work <ArrowUpRight size={17} /></Link>
  );

  return (
    <article className={cn('work-card', featured && 'work-card--featured')}>
      <div className="work-card__media">
        <img src={item.image} width="1600" height="900" loading="lazy" alt={`${item.title} ${item.industry} website ${item.kind}`} />
      </div>
      <div className="work-card__body">
        <p className="work-card__meta">{classification(item)}</p>
        <h3>{item.title}</h3>
        <p>{item.description}</p>
        <div className="tag-list">{item.tags.map((tag) => <span key={tag}>{tag}</span>)}</div>
        {primaryLink}
        {item.externalPreviewUrl ? <a className="work-card__external link-underline" data-arrow="true" href={item.externalPreviewUrl} target="_blank" rel="noreferrer">Open live preview <ArrowUpRight size={16} /></a> : null}
        {item.kind === 'concept' ? <small>Created for demonstration purposes · Not a commissioned client project</small> : null}
      </div>
    </article>
  );
}
